import React, { useEffect, useState } from "react";
import ModalCommon from "components/ModalCommon";
import SelectAutoComplete from "components/selectAutoCompleteG";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { CARGO_CODES } from "constants/permissions";
import { toast } from "react-toastify";
import { useEmpresaVendas } from "services/api/RoletaRecepcionista/get-empresa-vendas";
import { useEquipes } from "services/api/RoletaRecepcionista/get-equipes";
import { useUsuariosPorEquipe } from "services/api/RoletaRecepcionista/get-usuarios-equipe";
import { useAdicionarManualmente } from "services/api/RoletaRecepcionista/post-adicionar-corretor";
import { useBaterMao } from "services/api/RoletaRecepcionista/put-bater-mao";
import { usePlantaoVendas } from "contexts/PlantaoVendasContext";
import InputComponent from "components/InputG";
import * as S from "./styles"; // arquivo de estilos que mostraremos abaixo
import MaterialUI from "../../../../material-UI";

interface ModalCommonOptProps {
  icon: () => JSX.Element;
  title: string;
  open: boolean;
  setOpen: (value: boolean) => void;
  isCorretor: boolean;
  idRoletaCheckin: string;
  idCorretorSistemaOrigemAtual?: string;
  refetchListarFila: () => void;
  isAdicionarCorretor?: boolean;
}

const ModalCommonOpt: React.FC<ModalCommonOptProps> = ({
  icon,
  title,
  open,
  setOpen,
  isCorretor,
  idRoletaCheckin,
  idCorretorSistemaOrigemAtual,
  refetchListarFila,
  isAdicionarCorretor,
}) => {
  const { plantaoVendas: plantaoVendasRedux, codigoCargo2013 }: any =
    useSelector<RootStateOrAny, AuthState>((state) => state.user);

  const { plantaoVendas: plantaoVendasContext } = usePlantaoVendas();

  const isCorretorCargo = codigoCargo2013 === CARGO_CODES.CORRETOR;

  const idPdvAtivo = isCorretorCargo
    ? plantaoVendasContext?.value
    : plantaoVendasRedux?.id;

  const [imobiliaria, setImobiliaria] = useState<{
    value: string;
    label: string;
    empresaCyrela: boolean;
  } | null>(null);
  const [equipe, setEquipe] = useState<{ value: string; label: string } | null>(
    null
  );
  const [equipeInput, setEquipeInput] = useState<string>("");
  const [corretor, setCorretor] = useState<{
    value: string;
    label: string;
  } | null>(null);
  const [corretorInput, setCorretorInput] = useState<string>("");

  const {
    data: empresasVendas,
    isFetching: isFetchingEmpresas,
    refetch: refetchEmpresas,
  } = useEmpresaVendas({
    idPdv: idPdvAtivo,
  });

  useEffect(() => {
    if (open) {
      refetchEmpresas();
    }
  }, [open]);

  const {
    data: equipesVendas,
    refetch: refetchEquipes,
    isFetching: isFetchingEquipes,
  } = useEquipes({
    idEmpresaVendas: imobiliaria?.value || "",
  });

  const {
    data: usuariosPorEquipe,
    refetch: refetchUsuarios,
    isFetching: isFetchingUsuarios,
  } = useUsuariosPorEquipe({
    idUsuarioLider: equipe?.value || "",
  });

  const handleClose = () => {
    setOpen(false);
    setImobiliaria(null);
    setEquipe(null);
    setCorretor(null);
  };

  const { mutate: mutateAdicionarCorretor, isLoading: isLoadingAdicionar } =
    useAdicionarManualmente();

  const handleSubmitCorretor = () => {
    if (!corretor?.value && !corretorInput) return;

    const params = imobiliaria?.empresaCyrela
      ? {
          idRoletaCheckin,
          idCorretorSistemaOrigem: corretor?.value as string,
        }
      : {
          idRoletaCheckin,
          idImobiliaria: imobiliaria?.value,
          nomeImobiliaria: imobiliaria?.label,
          nomeCorretor: corretorInput,
          nomeEquipe: equipeInput,
        };

    mutateAdicionarCorretor(params as any, {
      onSuccess: () => {
        refetchListarFila();
        setCorretorInput("");
        setEquipeInput("");
        setImobiliaria(null);
        setEquipe(null);
        setCorretor(null);
        handleClose();
      },
      onError: (error: any) => {
        toast.error(error.response?.data?.notifications?.[0]?.message);
      },
    });
  };

  const { mutate: mutateBaterMao, isLoading: isLoadingBater } = useBaterMao();

  const handleSubmitBaterMao = () => {
    if (!corretor?.value) return;

    mutateBaterMao(
      {
        idRoletaCheckin,
        idCorretorSistemaOrigemAtual: idCorretorSistemaOrigemAtual || "",
        idCorretorSistemaOrigemNovo: corretor.value,
      },
      {
        onSuccess: () => {
          refetchListarFila();
          handleClose();
        },
        onError: (error: any) => {
          toast.error(error.response?.data?.notifications?.[0]?.message);
        },
      }
    );
  };

  return (
    <ModalCommon open={open} onClose={handleClose} setOpenModal={setOpen}>
      <S.Content>
        <S.Header>
          <S.IconContainer>{icon()}</S.IconContainer>
          <S.TitleText>{title}</S.TitleText>
        </S.Header>
        <S.Body>
          <S.FormGroup>
            <S.Label>Imobiliária</S.Label>
            <SelectAutoComplete
              placeholder="Digite a Imobiliária"
              data={
                empresasVendas?.map((item: any) => ({
                  value: item.id365,
                  label: item.nome,
                  empresaCyrela: item.empresaCyrela,
                })) || []
              }
              onChange={async (e: any) => {
                await setImobiliaria(e);
                setEquipe(null);
                setCorretor(null);
                setEquipeInput("");
                setCorretorInput("");
                refetchEquipes();
              }}
              disabled={isFetchingEmpresas}
              value={imobiliaria}
              borderRadius="8px"
            />
          </S.FormGroup>

          <S.FormGroup>
            <S.Label>Equipe</S.Label>
            {imobiliaria?.empresaCyrela === true ? (
              <SelectAutoComplete
                placeholder="Digite a Equipe"
                data={
                  equipesVendas?.map((item: any) => ({
                    value: item.idUsuarioLider,
                    label: item.nomeEquipe,
                  })) || []
                }
                onChange={async (e: any) => {
                  await setEquipe(e);
                  setCorretor(null);
                  setCorretorInput("");
                  refetchUsuarios();
                }}
                value={equipe}
                disabled={isFetchingEquipes || !imobiliaria?.value}
                borderRadius="8px"
              />
            ) : (
              <InputComponent
                placeholder="Digite a Equipe"
                value={equipeInput || ""}
                onChange={(e: any) => {
                  setEquipeInput(e.target.value);
                }}
              />
            )}
          </S.FormGroup>

          <S.FormGroup>
            <S.Label>Corretor</S.Label>
            {imobiliaria?.empresaCyrela === true ? (
              <SelectAutoComplete
                placeholder="Digite o Corretor"
                data={
                  usuariosPorEquipe?.map((item: any) => ({
                    value: item.idCorretor,
                    label: item.apelido,
                  })) || []
                }
                onChange={(e: any) => {
                  setCorretor(e);
                }}
                value={corretor}
                disabled={
                  isFetchingUsuarios || isFetchingEquipes || !equipe?.value
                }
                borderRadius="8px"
              />
            ) : (
              <InputComponent
                placeholder="Digite o Corretor"
                value={corretorInput || ""}
                onChange={(e: any) => {
                  setCorretorInput(e.target.value);
                }}
              />
            )}
          </S.FormGroup>
        </S.Body>

        <S.Footer>
          <S.SecondaryButton onClick={handleClose}>Cancelar</S.SecondaryButton>
          <S.PrimaryButton
            onClick={() => {
              if (isCorretor) {
                handleSubmitCorretor();
              } else {
                handleSubmitBaterMao();
              }
            }}
            disabled={!corretor?.value && !corretorInput}
          >
            {isLoadingAdicionar || isLoadingBater ? (
              <MaterialUI.CircularProgress size={18} color="inherit" />
            ) : (
              "Adicionar"
            )}
          </S.PrimaryButton>
        </S.Footer>
      </S.Content>
    </ModalCommon>
  );
};

export default ModalCommonOpt;
